import { transport } from 'config/transport';

export function callApiExportQuanLiTaiSan(congDoanId, academicYear, assetSource) {
    return transport.get(`/congDoan/${congDoanId}/assets/exportReport`, { params: { academicYear, assetSource }, responseType: 'blob' });
}
